<app-e-signing-canvas-toolbar
	[percentage]="percentage_()"
	(percentageChange)="setScale($event)"
	[maxPercentage_]="MAX_SCALE * 100"
	[minPercentage_]="MIN_SCALE * 100"
	(zoomIn)="zoomIn()"
	(zoomOut)="zoomOut()"
	class="w-full flex-shrink-0"
/>
<section
	(contextmenu)="$event.preventDefault()"
	#pdfContainer
	class="flex flex-col gap-4 py-4 flex-1 relative"
	[class.overflow-auto]="!isLoading()"
	[class.overflow-hidden]="isLoading()"
>
	@if (isLoading()) {
		<div
			class="absolute inset-0 bg-white/75 z-50 flex items-center justify-center"
		>
			<div class="flex flex-col items-center gap-3">
				<i-tabler
					name="loader-2"
					class="animate-spin text-gray-950 size-8"
				></i-tabler>
				<p class="text-sm text-gray-700">Loading document preview...</p>
			</div>
		</div>
	}
	@for (page of pages_(); track page.documentPageNumber) {
		<div class="relative mx-auto">
			@for (block of page.blocks; track block.id) {
				<div
					class="absolute z-10"
					[style.left.px]="block.x * scale_()"
					[style.top.px]="block.y * scale_()"
					[style.width.px]="block.showWidth"
					[style.height.px]="block.showHeight"
					(dragover)="onDragOver($event)"
					(drop)="onDrop($event, page.documentPageNumber)"
				>
					<app-e-signing-canvas-block
						[ngClass]="
							block.elementType === ESigningBlockType.CHECKBOX
								? '[&>button]:!justify-center [&>button]:!p-0 [&>button]:!gap-0'
								: ''
						"
						[blockType]="block.elementType"
						[textDefaultValue]="block.textDefaultValue || ''"
						(textDefaultValueChange)="onBlockValueChange(block, $event)"
						(blockFocus)="onBlockFocus(block.id)"
						(blockBlur)="onBlockBlur()"
						(isEditingChanged)="onBlockEditingStateChange(block.id, $event)"
						(dragstart)="setActiveDraggedBlock($event, block)"
						(dragend)="setActiveDraggedBlock($event)"
						(keydown.delete)="onDeleteBlock($event, block)"
						(keydown.backspace)="onDeleteBlock($event, block)"
						(keydown.control.c)="onCopyBlock($event, block)"
						(keydown.meta.c)="onCopyBlock($event, block)"
						[disabled]="readonly()"
						[draggable]="!readonly()"
						[variant]="block.UIVariant"
						[attr.data-block-id]="block.id"
					/>
					@if (
						block.elementType === ESigningBlockType.TEXT &&
						focusedBlockId_() === block.id &&
						editingBlockId_() !== block.id
					) {
						<!-- Top-left handle -->
						<span
							class="absolute left-0 top-0 size-3 z-20 -translate-x-1/2 -translate-y-1/2"
							[ngClass]="{ 'cursor-nwse-resize': !readonly() }"
							(mousedown)="onResizeStart($event, block, 'top-left')"
						></span>
						<!-- Top-right handle -->
						<span
							class="absolute right-0 top-0 size-3 z-20 translate-x-1/2 -translate-y-1/2"
							[ngClass]="{ 'cursor-nesw-resize': !readonly() }"
							(mousedown)="onResizeStart($event, block, 'top-right')"
						></span>
						<!-- Bottom-left handle -->
						<span
							class="absolute left-0 bottom-0 size-3 z-20 -translate-x-1/2 translate-y-1/2"
							[ngClass]="{ 'cursor-nesw-resize': !readonly() }"
							(mousedown)="onResizeStart($event, block, 'bottom-left')"
						></span>
						<!-- Bottom-right handle -->
						<span
							class="absolute right-0 bottom-0 size-3 z-20 translate-x-1/2 translate-y-1/2"
							[ngClass]="{ 'cursor-nwse-resize': !readonly() }"
							(mousedown)="onResizeStart($event, block, 'bottom-right')"
						></span>
					}
				</div>
			}
			<div
				[style.width.px]="page.width * scale_()"
				[style.height.px]="page.height * scale_()"
			>
				<img
					#page
					loading="lazy"
					[alt]="'Page ' + page.documentPageNumber + ' of ' + page.fileName"
					(dragstart)="$event.preventDefault()"
					(dragover)="onDragOver($event)"
					(drop)="onDrop($event, page.documentPageNumber)"
					(click)="onPageClick($event, page.documentPageNumber)"
					[src]="page.signedUrl"
					[attr.data-page]="page.documentPageNumber"
					[class.cursor-pointer]="pendingBlock() || pendingDragBlock()"
					class="rounded-lg w-full h-full object-cover shadow-md"
				/>
			</div>
		</div>
	}
</section>
